// Navigation Observer Trigger
window.addEventListener('load', event => {
    const scrollNavigation = document.getElementById('#top-of-site-pixel-anchor');
    if(scrollNavigation) {
        if (
            'IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype
        ) {
            const callback = function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('pixel-observed');
                    } else {
                        entry.target.classList.remove('pixel-observed');
                    }
                });
            };

            const observer = new IntersectionObserver(callback);
            const anchor = document.getElementById('#top-of-site-pixel-anchor');

            observer.observe(anchor);
        }
    }
});
